// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"edit-report-name-modal_btnWrapper__AMnvk","errorMsg":"edit-report-name-modal_errorMsg__1Ytuv"};